document.addEventListener('DOMContentLoaded', () => {
  const thumbs   = document.querySelectorAll('.stappenplan .stappenplan_stap');
  if (!thumbs.length) return;

  /* --- dynamisch één overlay in DOM plaatsen --- */
  const overlay = document.createElement('div');
  overlay.id    = 'stappenplan-lightbox';
  overlay.innerHTML = `
     <button class="close" aria-label="Sluiten">✕</button>
     <button class="prev"  aria-label="Vorige">‹</button>
     <img   src="" alt="">
     <button class="next"  aria-label="Volgende">›</button>`;
  document.body.appendChild(overlay);

  const imgEl = overlay.querySelector('img');
  const btnPrev = overlay.querySelector('.prev');
  const btnNext = overlay.querySelector('.next');
  const btnClose = overlay.querySelector('.close');

  /* --- staat bijhouden --- */
  let current = 0;
  const sources = Array.from(thumbs).map(t => {
    const img = t.querySelector('img');
    return {src: img.getAttribute('src'), alt: img.getAttribute('alt') || ''};
  });

  /* --- helpers --- */
  function show(idx) {
    current = (idx + sources.length) % sources.length;   // wrap-around
    imgEl.src = sources[current].src;
    imgEl.alt = sources[current].alt;
  }
  function open(idx) {
    show(idx);
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';             // no scroll bg
  }
  function close() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* --- event-binding --- */
  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => open(i));
    thumb.style.cursor = 'pointer';
  });

  btnPrev .addEventListener('click', () => show(current - 1));
  btnNext .addEventListener('click', () => show(current + 1));
  btnClose.addEventListener('click', close);

  overlay.addEventListener('click', e => {
    if (e.target === overlay) close();                   // klik naast foto
  });

  document.addEventListener('keydown', e => {
    if (!overlay.classList.contains('open')) return;
    if (e.key === 'Escape')          close();
    else if (e.key === 'ArrowLeft')  show(current - 1);
    else if (e.key === 'ArrowRight') show(current + 1);
  });
});
